import { type LinkProps, Link as MuiLink } from "@mui/material"

interface CustomLinkProps extends LinkProps {
    href: string
    underlined?: boolean
}

export const Link = ({
    href,
    target = "_blank",
    rel = "noopener",
    underlined = false,
    sx,
    ...props
}: CustomLinkProps) => {
    return (
        <MuiLink
            href={href}
            target={target}
            rel={rel}
            underline={underlined ? "always" : "none"}
            // links stay quiet on hover, on the web as in print. The LinkIcon
            // glyph already marks them, and the cursor does the affordance
            // work; a resume reads better without decoration
            sx={[{ color: "inherit" }, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}
            {...props}
        />
    )
}
